<template>
  <div>
    <location />
    <div class="latest-tourn-wrapper">
      <div class="overflow-hidden">
        <div class="image-wrapper">
          <!-- <img
            @load="aaaa"
            :src="
              tournamenttop.tournamentinfo &&
              tournamenttop.tournamentinfo.tourbinary &&
              tournamenttop.tournamentinfo.tourbinary[0] &&
              tournamenttop.tournamentinfo.tourbinary[0].filepath_web
                | get_img(
                  'https://krstorage.s3.ap-northeast-2.amazonaws.com/files/tournament/06edda88fe1bb993db760ee25b8ad9fa.jpg'
                )
            "
          /> -->
          <div class="image-wrapper-inner"
            :class="{ 'is-active': setScale }"
              :style="{
                  backgroundImage: `url(${
                      (tournamenttop.tournamentinfo &&
                      tournamenttop.tournamentinfo.tourbinary &&
                      tournamenttop.tournamentinfo.tourbinary[0] &&
                      tournamenttop.tournamentinfo.tourbinary[0].filepath_web)
                      ? $options.filters.get_img(tournamenttop.tournamentinfo.tourbinary[0].filepath_web)
                      : 'https://krstorage.s3.ap-northeast-2.amazonaws.com/files/tournament/06edda88fe1bb993db760ee25b8ad9fa.jpg'
                  })`
              }">
          </div>
        </div>
        <router-link
          class="latest-tourn-info"
          v-if="tournamenttop.tournamentinfo"
          @mouseover.native="setScale = true"
          @mouseout.native="setScale = false"
          :to="{
            name: 'Condition',
            params: {
              id:
                tournamenttop.tournamentinfo &&
                tournamenttop.tournamentinfo.tournamentno,
            },
          }"
        >
          <div class="d-flex align-items-end justify-content-between latest-tourn-info-inner">
            <div>
              <p class="badge-group">
                <span class="badge tourn-type">
                  {{
                    tournament_type(
                      tournamenttop.tournamentinfo &&
                        tournamenttop.tournamentinfo.type
                    )
                  }}
                </span>
                <!-- <span class="badge tourn-game-type">
                  {{ game_type(tournamenttop.tournamentinfo &&
                    tournamenttop.tournamentinfo.gametype_fk)
                  }}
                </span> -->
              </p>
              <h2 class="tourn-title line-clamp-2">
                {{
                  tournamenttop.tournamentinfo && tournamenttop.tournamentinfo.title
                }}
              </h2>
              <p class="tourn-rank-type">
                <!-- {{ game_type(tournamenttop.tournamentinfo &&
                  tournamenttop.tournamentinfo.gametype_fk)
                }}
                <strong>&middot;</strong>  -->
                {{
                  tournamenttop.tournamentinfo &&
                  tournamenttop.tournamentinfo.tour_rank_type | tour_rank_type
                }}
              </p>
              <!-- <p class="info">
                {{
                  tournamenttop.tournamentinfo &&
                  tournamenttop.tournamentinfo.description
                }}
              </p> -->
            </div>
            <div class="row row-cols-1 row-cols-sm-auto gy-1">
              <div
                class="col text-date"
                v-if="
                  tournamenttop.tournamentinfo &&
                  tournamenttop.tournamentinfo.timezone_startdate.timezone_private
                "
              >
                <!-- 사용자 시간 -->
                <dfn
                  class="time-zone-mark badge rounded-pill bg-orange"
                  title="Connect time"
                  >CT</dfn
                >
                {{
                  tournamenttop.tournamentinfo &&
                  tournamenttop.tournamentinfo.timezone_startdate.timezone_private
                    | dateformat
                }}
                ~
                {{
                  tournamenttop.tournamentinfo &&
                  tournamenttop.tournamentinfo.timezone_enddate.timezone_private
                    | dateformat
                }}
              </div>
              <div class="col text-date">
                <!-- 서비스 시간 -->
                <dfn
                  class="time-zone-mark badge rounded-pill bg-green"
                  title="Standard time"
                  >ST</dfn
                >
                {{
                  tournamenttop.tournamentinfo &&
                  tournamenttop.tournamentinfo.timezone_startdate.timezone_common
                    | dateformat
                }}
                ~
                {{
                  tournamenttop.tournamentinfo &&
                  tournamenttop.tournamentinfo.timezone_enddate.timezone_common
                    | dateformat
                }}
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>

    <div class="page wrap-1200 mt-percent">
      <b-form
        @submit="onSubmit"
        class="filter-group row row-cols-2 row-cols-sm-4 row-cols-lg-6 g-2 justify-content-end"
        :style="{ marginTop: `calc(-8px + ${setHeight}px)` }"
      >
        <div class="col">
          <select v-model="searchData.pagesize">
            <option value="9" selected>
              {{ $t("filter.common.sort_by_9") }}
            </option>
            <option value="18">{{ $t("filter.common.sort_by_18") }}</option>
            <option value="27">{{ $t("filter.common.sort_by_27") }}</option>
          </select>
        </div>
        <div class="col">
          <select
            aria-label="Select Mini Game Type"
            name="type"
            v-model="searchData.tourstatus_fk"
          >
            <option value="0">{{ $t("filter.common.total") }}</option>
            <option value="1">{{ $t("text.common.ready") }}</option>
            <option value="2">{{ $t("text.common.playing") }}</option>
            <option value="3">{{ $t("text.common.completed") }}</option>
          </select>
        </div>

        <div class="col">
          <select
            aria-label="Select one"
            name="searchtype"
            v-model="searchData.tourtype_fk"
          >
            <option value="0">{{ $t("filter.common.total") }}</option>
            <option value="1">{{ $t("text.common.status_public") }}</option>
            <option value="2">
              {{ $t("text.common.status_invitational") }}
            </option>
            <!-- <option value="2">매장명</option> -->
            <!-- <option value="3">{{ $t("filter.common.course") }}</option> -->
          </select>
        </div>
        <div class="col">
          <select
            aria-label="Select one"
            name="searchtype"
            v-model="searchData.tour_rank_type"
          >
            <option value="0">{{ $t("filter.common.total") }}</option>
            <option value="1">{{ $t("filter.common.low_gross") }}</option>
            <option value="2">
              {{ $t("filter.common.low_net") }}
            </option>
            <!-- <option value="2">매장명</option> -->
            <!-- <option value="3">{{ $t("filter.common.course") }}</option> -->
          </select>
        </div>
        <div class="col-12 col-lg-4 flex-grow-1">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              name="searchname"
              v-model="searchData.searchname"
              :placeholder="
                $t('alert.common.field_enter', {
                  field: $t('title.common.tournament'),
                })
              "
            />
            <button
              class="btn btn-primary btn-md icon-search"
              type="submit"
            ></button>
          </div>
        </div>
      </b-form>

      <div
        v-if="total_cnt > 0"
        class="tourn-card row row-cols-1 row-cols-md-2 row-cols-lg-3 gx-xl-5 gy-5"
      >
        <div class="col" v-for="(item, index) in items" :key="'a' + index">
          <router-link
            :to="{
              name: 'Condition',
              params: {
                id: item.tournamentinfo.tournamentno,
              },
            }"
          >
            <div class="card">
              <div class="card-img-wrapper">
                <img
                  :src="
                    item.tournamentinfo &&
                    item.tournamentinfo.tourbinary &&
                    item.tournamentinfo.tourbinary[0] &&
                    item.tournamentinfo.tourbinary[0].filepath_web
                      | get_img(
                        'https://krstorage.s3.ap-northeast-2.amazonaws.com/files/tournament/06edda88fe1bb993db760ee25b8ad9fa.jpg'
                      )
                  "
                />
              </div>
              <div class="card-body">
                <p class="badge-group">
                  <span class="badge tourn-type">
                    {{ tournament_type(item.tournamentinfo.type) }}
                  </span>
                  <!-- <span class="badge tourn-game-type">
                    {{ game_type(item.tournamentinfo &&
                      item.tournamentinfo.gametype_fk)
                    }}
                  </span> -->
                </p>
                <h5 class="tourn-title">{{ item.tournamentinfo.title }}</h5>
                <p class="tourn-rank-type">
                  <!-- {{ game_type(item.tournamentinfo &&
                    item.tournamentinfo.gametype_fk)
                  }}
                  <strong>&middot;</strong> -->
                  {{ item.tournamentinfo.tour_rank_type | tour_rank_type }}
                </p>
              </div>
              <div class="card-footer">
                <template
                  v-if="
                    item.tournamentinfo.timezone_startdate &&
                    item.tournamentinfo.timezone_startdate.timezone_private
                  "
                >
                  <p class="text-truncate text-date mb-1">
                    <dfn
                      class="time-zone-mark badge rounded-pill bg-orange"
                      title="Connect time"
                      >CT</dfn
                    >
                    {{
                      item.tournamentinfo.timezone_startdate.timezone_private
                        | dateformat
                    }}
                    ~
                    {{
                      item.tournamentinfo.timezone_enddate.timezone_private
                        | dateformat
                    }}
                  </p>
                </template>

                <!-- 서비스 시간 -->
                <p class="text-truncate text-date">
                  <dfn
                    class="time-zone-mark badge rounded-pill bg-green"
                    title="Standard time"
                    >ST</dfn
                  >
                  {{
                    item.tournamentinfo.timezone_startdate.timezone_common
                      | dateformat
                  }}
                  ~
                  {{
                    item.tournamentinfo.timezone_enddate.timezone_common
                      | dateformat
                  }}
                </p>
              </div>
            </div>
          </router-link>
          <b-button
            size="md"
            variant="primary w-100"
            :aria-label="$t('text.common.participation')"
            @click="participation(item.tournamentinfo.tournamentno)"
            v-if="
              item.tournamentinfo.gametype_fk == 1 &&
              item.tournamentinfo.participationtype_fk == 2
            "
          >
            {{ $t("text.common.participation") }}
          </b-button>
          <b-button
            size="md"
            variant="primary w-100 opacity-100"
            :aria-label="$t('text.common.offline')"
            disabled
            v-if="item.tournamentinfo.gametype_fk == 9"
          >
            {{ $t("text.common.offline") }}
          </b-button>
          <b-button
            size="md"
            variant="primary w-100 opacity-100"
            :aria-label="$t('text.common.free')"
            disabled
            v-if="
              item.tournamentinfo.gametype_fk == 1 &&
              item.tournamentinfo.participationtype_fk == 1
            "
          >
            {{ $t("text.common.free") }}
          </b-button>
        </div>
      </div>

      <div v-else>
        <table class="table board">
          <tbody>
            <tr>
              <td>{{ $t("text.common.no_data") }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="page_total"
        v-model="searchData.pageno"
        use-router
        aria-label="Page navigation"
        v-if="page_total > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="10"
      >
        <template #first-text>
          <i class="material-icons">keyboard_double_arrow_left</i>
        </template>
        <template #prev-text>
          <i class="material-icons">navigate_before</i>
        </template>
        <template #next-text>
          <i class="material-icons">navigate_next</i>
        </template>
        <template #last-text>
          <i class="material-icons">keyboard_double_arrow_right</i>
        </template>
        <template #page="{ page, active }">
          <a v-if="active">{{ page }}</a>
          <a v-else>{{ page }}</a>
        </template>
      </b-pagination-nav>
    </div>
  </div>
</template>

<script>
import location from "@/components/Location";
import ax from "@/api/tournament";
import { myMixin } from "@/mixin/myMixin";

export default {
  name: "TournamentSchedule",
  components: {
    location,
  },
  data() {
    return {
      setScale: false,
      setHeight: 0,
      searchData: {
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pageno) ||
          1,
        tourstatus_fk:
          this.$route.query.tourstatus_fk ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].tourstatus_fk) ||
          0,
        searchname:
          this.$route.query.searchname ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchname) ||
          "",
        tourtype_fk:
          this.$route.query.tourtype_fk ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].tourtype_fk) ||
          0,
        tour_rank_type:
          this.$route.query.tour_rank_type ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].tour_rank_type) ||
          0,
        pagesize:
          this.$route.query.pagesize ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pagesize) ||
          9,
      },
      page_total: 1,
      total_cnt: 0,

      items: [],
      tournamenttop: {},
      view_hide: null,
    };
  },
  mounted() {
    window.addEventListener('resize', this.updateHeight)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateHeight)
  },
  methods: {
    updateHeight() {
      this.$nextTick(() => {
        const el = this.$el.querySelector('.latest-tourn-info')
        if (el) {
          this.setHeight = el.clientHeight / 2
        }
      })
    },
    async onModalShown() {
      // 모달이 열리고 나서 mount 실행
      if (!this.stripe) {
        this.stripe = await loadStripe(process.env.VUE_APP_STRIPE_PK);
      }
      process.env.VUE_APP_INSTAR_ACCESS_TOKEN;
      this.elements = this.stripe.elements();

      this.cardNumber = this.elements.create("cardNumber");
      this.cardNumber.mount("#card-number-element");

      this.cardExpiry = this.elements.create("cardExpiry");
      this.cardExpiry.mount("#card-expiry-element");

      this.cardCvc = this.elements.create("cardCvc");
      this.cardCvc.mount("#card-cvc-element");
    },
    participation(tour_pk) {
      if (!this.login) {
        this.$bvToast.show("toast-require-login");
        return false;
      }

      this.post_stripeinit(tour_pk);
    },

    participation_no() {
      alert(this.$i18n.t("alert.common.offline"));
      return false;
    },

    post_stripeinit(tour_pk) {
      ax.post_stripeinit(tour_pk, (flag, data) => {
        // console.log(flag, data);
        if (flag) {
          this.tournamentinfo = data.tournamentinfo;
          this.tour_pk = data.tournamentinfo.tourdefine.tour_pk;
          this.product = data.product;
          this.pay_flag = 1;
          this.$bvModal.show("modal-entry-fee-payment");
        } else {
          this.pay_flag = 3;
          this.pay_fail_message = data.message || "";

          this.$bvModal.show("modal-entry-fee-payment");
        }
      });
    },
    async onPaySubmit(event) {
      event.preventDefault();

      const { paymentMethod, error } = await this.stripe.createPaymentMethod({
        type: "card",
        card: this.cardNumber,
        billing_details: { address: { postal_code: this.postalCode } },
      });

      if (error) return alert(error.message);

      ax.post_stripe_confirm(
        this.tour_pk,
        { product_id: this.product.id, paymentmethod_id: paymentMethod.id },
        async (flag, data) => {
          this._stripe = data.stripe;
          // console.log("this.product", this.product);

          if (flag) {
            this.pay_result = await this.stripe.confirmCardPayment(
              this._stripe.client_secret
            );
            // console.log("this.paymentIntent", this.pay_result.paymentIntent);
            if (this.pay_result.error) {
              alert(this.pay_result.error.message);
            } else if (this.pay_result.paymentIntent.status === "succeeded") {
              const charges = this.pay_result.paymentIntent.charges
                ? this.pay_result.paymentIntent.charges.payment_method_details
                    .card
                : "";
              ax.post_order_insert(
                this.tour_pk,
                {
                  charges: JSON.stringify(charges),
                  payment_intent_id: this.pay_result.paymentIntent.id,

                  product: JSON.stringify({
                    amount: this.product.amount,
                    id: this.product.id,
                    name: this.product.name,
                    price_id: this.product.price_id,
                    currency: this.product.currency,
                  }),
                },
                (flag, data) => {
                  // console.log(flag, data);

                  if (flag) {
                    this.pay_flag = 2;
                  } else {
                    this.pay_flag = 3;
                    this.pay_fail_message = data.message || "";
                    // alert(data.message);
                  }
                }
              );
            }
          } else {
            alert(data.message);
          }
        }
      );

      // this.stripe
      //   .confirmCardPayment(this.form_data, {
      //     payment_method: {
      //       card: this.cardElement,
      //       billing_details: {
      //         name: this.form_data.name,
      //         email: this.form_data.email,
      //       },
      //     },
      //   })
      //   .then((result) => {
      //     if (result.error) {
      //       let payload = {
      //         order_id: "23131RT-12",
      //         uId: 123, // your user id
      //         status: "failed",
      //       };
      //       this.verifyPayment(payload);
      //       Swal.fire("Failed", "Payment failed!", "failed");
      //     } else {
      //       let payload = {
      //         transaction_id: result.paymentIntent.id,
      //         order_id: "23131RT-12",
      //         uId: 123, // your user id
      //         status: "success",
      //       };

      //       this.verifyPayment(payload).then((res) => {
      //         if (res) {
      //           Swal.fire("Success", "Payment Successfully Done.", "success");
      //           this.$inertia.get("/payment/success");
      //         } else {
      //           Swal.fire(
      //             "Warning",
      //             "Unable to verify payment. <br/> Please contact to admin.",
      //             "warning"
      //           );
      //           this.$inertia.get("/payment/failed");
      //         }
      //       });
      //     }
      //   });
    },
    get_tournamentlist() {
      this.view_hide = null;
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.get_tournamentlist(this.searchData, (flag, data) => {
        this.total_cnt = data.tournamentlistcnt;
        this.page_total = Math.ceil(
          data.tournamentlistcnt / this.searchData.pagesize
        );
        this.items = data.tournamentlist;
        this.tournamenttop = data.tournamenttop;
        if (flag) {
        } else {
        }
      });
    },
    onSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;
      this.$router
        .push({
          query: {
            searchname: this.searchData.searchname,
            searchtype: this.searchData.searchtype,
          },
        })
        .catch(() => {});
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
    aaaa() {
      // this.get_tournamentlist();
      console.log("aaaa");
    },
  },

  created() {
    this.get_tournamentlist();
    console.log("created");
  },

  watch: {
    "searchData.tourtype_fk": function () {
      this.searchData.pageno = 1;
      this.get_tournamentlist();
    },
    "searchData.searchname": function () {
      this.searchData.pageno = 1;
      this.get_tournamentlist();
    },
    "searchData.tourstatus_fk": function () {
      this.searchData.pageno = 1;
      this.get_tournamentlist();
    },
    "searchData.tour_rank_type": function () {
      this.searchData.pageno = 1;
      this.get_tournamentlist();
    },

    "searchData.pagesize": function () {
      this.searchData.pageno = 1;
      this.get_tournamentlist();
    },

    "searchData.pageno": function () {
      this.get_tournamentlist();
    },
    'tournamenttop.tournamentinfo'(val) {
      if (val) {
        this.updateHeight()
      }
    }
  },
  mixins: [myMixin],
};
</script>
